/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Group from 'entities/Group';
import View from 'components/View';
import GroupViewHeader from 'groups/components/GroupViewHeader';
import GroupSignupSetupListener from 'groups/components/GroupSignupSetupListener';
import GroupViewQueryParametersConsumer from 'groups/components/GroupViewQueryParametersConsumer';

import './styles/GroupView.scss';

type Props = {
  group: Group,
  className?: string,
  children?: React.Node,
  refetch?: () => void,
};

export class GroupView extends React.Component<Props> {
  render() {
    const { group, refetch } = this.props;
    const orgId = group.getStaffClassOrgId();
    // ^ this should not be here, we already pass the group.

    // $FlowFixMe
    const newChildren = React.cloneElement(this.props.children, { group, orgId, refetch });

    return (
      <div className="GroupView">
        <GroupSignupSetupListener group={group} />
        <GroupViewQueryParametersConsumer group={group} />
        <GroupViewHeader group={group} />
        <View full className={cx('GroupView-view', this.props.className)}>
          {newChildren}
        </View>
      </div>
    );
  }
}

export default GroupView;
